import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { Grid } from '@material-ui/core';

import imgDufault from './imgs/Dufault.jpg';
import imgFraisse from './imgs/Fraisse.png';
import imgPerondi from './imgs/Perondi.jpg';
import imgCullen from './imgs/Cullen.jpg';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  media: {
    height: 400,
  },
  aLink : {
    textDecoration: 'none',
    color : "#3f51b5"
  }
}));

function AboutUsComponent (){
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const openEmail = (email) => {
      window.location.href = `mailto:${email}`;
    };

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              <Tab label="Development team" {...a11yProps(0)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <Grid container spacing={3}>
              <Grid item lg={3} md={4} sm={6}>
                <Card className={classes.root}>
                  <CardActionArea>
                    <CardMedia className={classes.media} image={imgDufault} title=""/>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        Nicholas S. Dufault
                      </Typography>
                      <Typography variant="body2" color="textSecondary" component="p">
                        Associate Professor at UF/IFAS Plant Pathology department.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button size="small" color="primary">
                      <a rel="noopener noreferrer" target="_blank" className={classes.aLink} href="mailto:nsdufault@ufl.edu">Email</a> 
                    </Button>
                    <Button size="small" color="primary">
                      <a rel="noopener noreferrer" target="_blank" className={classes.aLink} href="https://plantpath.ifas.ufl.edu/people/faculty-pages/nicholas-dufault/">Website</a> 
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item lg={3} md={4} sm={6}>
                <Card className={classes.root}>
                  <CardActionArea>
                    <CardMedia className={classes.media} image={imgFraisse} title=""/>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        Clyde W. Fraisse
                      </Typography>
                      <Typography variant="body2" color="textSecondary" component="p">
                        Professor at UF/IFAS Agricultural & Biological Engineering department.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button size="small" color="primary">
                      <a rel="noopener noreferrer" target="_blank" className={classes.aLink} href="mailto:cfraisse@ufl.edu">Email</a> 
                    </Button>
                    <Button size="small" color="primary">
                      <a rel="noopener noreferrer" target="_blank" className={classes.aLink} href="https://abe.ufl.edu/people/faculty/clyde-fraisse/">Website</a> 
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item lg={3} md={4} sm={6}>
                <Card className={classes.root}>
                  <CardActionArea>
                    <CardMedia className={classes.media} image={imgPerondi} title=""/>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        Daniel Perondi
                      </Typography>
                      <Typography variant="body2" color="textSecondary" component="p">
                        PhD student at UF/IFAS Agricultural & Biological Engineering department.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button size="small" color="primary">
                      <a rel="noopener noreferrer" target="_blank" className={classes.aLink} href="mailto:dperondi@ufl.edu">Email</a> 
                    </Button>
                    <Button size="small" color="primary">
                      <a rel="noopener noreferrer" target="_blank" className={classes.aLink} href="http://agroclimate.org">Website</a> 
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item lg={3} md={4} sm={6}>
                <Card className={classes.root}>
                  <CardActionArea>
                    <CardMedia className={classes.media} image={imgCullen} title=""/>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        Matthew A. Cullen
                      </Typography>
                      <Typography variant="body2" color="textSecondary" component="p">
                        PhD student at UF/IFAS Plant Pathology department.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                  <Button size="small" color="primary">
                      <a rel="noopener noreferrer" target="_blank" className={classes.aLink} href="mailto:mcullen1@ufl.edu">Email</a> 
                    </Button>
                    <Button size="small" color="primary">
                      <a rel="noopener noreferrer" target="_blank" className={classes.aLink} href="https://plantpath.ifas.ufl.edu/">Website</a> 
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </TabPanel>
        </Paper> 
      </div>
    )
}

export default {
    routeProps: {
        path: '/aboutus',
        component: AboutUsComponent
    },
    name: 'About Us',
}
